import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Alert from "components/alert-view";
import { FormattedMessage, defineMessages } from "react-intl";
import classes from "./alert.scss";
import appconfig from "config/appconfig";
import { Button, Typography } from "@getgo/chameleon-web-react-wrapper";
import st from "core/shared-translations";
import { AlertOutlinedIcon } from '@getgo/chameleon-icons/react';
import useAnalyticsHelpers from "lib/analytics-helpers";

const t = defineMessages({
  "alert.auth.expired.message": {
    id: "alert.auth.expired.message",
    defaultMessage: "Your session has expired.",
  },
  "alert.auth.expired.buttonLogin": {
    id: "alert.auth.expired.buttonLogin",
    defaultMessage: "To continue, sign in to your account.",
  },
});

export const AlertAuthExpired = ({ handleLogin, handleAlertDismiss }) => {
  const { track } = useAnalyticsHelpers();

  useEffect(() => {
    track('Alert Shown', {
      alertType: 'auth_expired',
      alertMessage: 'Your session has expired',
    });
  }, [track]);

  const handleLoginClick = () => {
    track('Alert Action Clicked', {
      alertType: 'auth_expired',
      action: 'sign_in',
    });
    handleLogin();
  };

  const handleDismissClick = () => {
    track('Alert Dismissed', {
      alertType: 'auth_expired',
    });
    handleAlertDismiss();
  };

  return (
    <Alert
      type={appconfig.alertTypes.DANGER}
      icon={<AlertOutlinedIcon/>}
      body={
          <span className={classes.bannerMessageText}>
            <FormattedMessage {...t["alert.auth.expired.message"]} />
            <span className={classes.secondPartOfText}>
              <FormattedMessage {...t["alert.auth.expired.buttonLogin"]} />
            </span>
          </span>
      }
      action={
        <Button
          id="auth-expired-login"
          size="small"
          variant="neutral"
          onClick={handleLoginClick}
        >
          <Typography color="type-color-inverted">
            <FormattedMessage {...st["shared.signin"]} />
          </Typography>
        </Button>
      }
      handleDismiss={handleDismissClick}
    />
  );
};

AlertAuthExpired.propTypes = {
  handleAlertDismiss: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired,
};

export default AlertAuthExpired;
